import * as yup from '@if/core/yup'
import type { InferType } from '@if/core/yup'

export const bulkAssignTicketSchema = yup.object({
  ticketNumber: yup
    .string()
    .required('validation.required')
    .matches(/^\d+$/, 'validation.validNumber')
    .test('positive', 'validation.positive', (value) => {
      const num = parseInt(value || '', 10)
      return !isNaN(num) && num > 0
    })
    .default(''),
})

export type BulkAssignTicketFormData = InferType<typeof bulkAssignTicketSchema>
